import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class LogService {

    getLogs(itemId: number, tipoLog: number): Observable<HttpResponse<any>>{
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/log/' + itemId + '?logTipo=' + tipoLog, { observe: 'response' })
    }

    getTooltipText(ultimoLog?: any) {
    if (!ultimoLog) {
      return 'Nenhum histórico encontrado.';
    }

    const formattedDate = new Date(ultimoLog.data).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });

    // 0 - Emitido / 1 - Atualizado / 2 - Cancelado / 3 - Baixado / 4 - Adicionado na fila / 5 - Erro

    switch (ultimoLog.logTipoEvento) {
      case 0:
        return `${ultimoLog.textoLog} ${formattedDate}`;
      case 1:
        return `${ultimoLog.textoLog} ${formattedDate}`;
      case 2:
        return `${ultimoLog.textoLog} ${formattedDate}`;
      case 3:
        return `${ultimoLog.textoLog} ${formattedDate}`;
      case 4:
        return `${ultimoLog.textoLog} ${formattedDate}`;
      case 5:
        return `${ultimoLog.textoLog} ${formattedDate}`;
      default:
        return 'Nenhum histórico encontrado';
    }
  }

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

    }
}
